import React, { createContext, useState } from "react";

const SelectedFormContext = createContext(undefined);

const SelectedFormProvider = ({ children }) => {
	const [formData, setFormData] = useState(undefined);

	return (
		<SelectedFormContext.Provider value={{ formData, setFormData }}>
			{children}
		</SelectedFormContext.Provider>
	)
};

export { SelectedFormProvider, SelectedFormContext };